import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockGallerySlider from "./blocks/BlockGallerySlider";

import Share from "./components/Share";
import BlockAnchor from "./blocks/BlockAnchor";
import Glossy from "./components/Glossy";
import BlockDivision from "./blocks/BlockDivision";
import BlockKeyNumbers from "./blocks/BlockKeyNumbers";
import BlockMap from "./blocks/BlockMap";
import BlockCta from "./blocks/BlockCta";
import PageDivision from "./pages/PageDivision";
import PageSociety from "./pages/PageSociety";
import CursorFollower from "./components/CursorFollower";
import BlockWall from "./blocks/BlockWall";
import BlockJobs from "./blocks/BlockJobs";
import PageSingleExpertise from "./pages/PageSingleExpertise";
import SwiperDivision from "./components/SwiperDivision";
import BlockCertification from "./blocks/BlockCertification";
import BlockMarket from "./blocks/BlockMarket";
import BlockHistory from "./blocks/BlockHistory";
import Shapes from "./components/Shapes";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	NavsFull.init();
	NavsBurger.init();
	CursorFollower.init();

	// Blocks
	BlockAnchor.init();
	BlockBanner.init();
	BlockCertification.init();
	BlockCta.init();
	BlockGallerySlider.init();
	BlockHistory.init();
	BlockJobs.init();
	BlockKeyNumbers.init();
	BlockMap.init();
	BlockMarket.init();

	BlockDivision.init();
	BlockWall.init();

	PageDivision.init();
	PageSociety.init();
	PageSingleExpertise.init();

    Shapes.init();

	Glossy.init();
	SwiperDivision.init();

	Share.init();
});
